import { render, staticRenderFns } from "./MaxMarketingRiskModal.vue?vue&type=template&id=67a7c7ee"
import script from "./MaxMarketingRiskModal.vue?vue&type=script&lang=js"
export * from "./MaxMarketingRiskModal.vue?vue&type=script&lang=js"
import style0 from "./MaxMarketingRiskModal.vue?vue&type=style&index=0&id=67a7c7ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports